import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import useObjectCard from "@molecules/ObjectCard/ObjectCard.context"

import styles from "./ObjectCardAttributes.module.scss"
import { ObjectCardAttributesProps } from "./ObjectCardAttributes.types"

// Placeholder badge widths from the loading state design: three on the first row, two on the second.
const LOADING_BADGE_WIDTHS = [96, 96, 80, 80, 80]
// Icon is replaced by a skeleton while loading, but the "icon" variant requires one.
const loadingBadgeIcon = faIcon({ name: "clock", style: "regular" })

export default function ObjectCardAttributes(props: ObjectCardAttributesProps) {
    const { children, className } = props

    const { isLoading } = useObjectCard()

    if (isLoading) {
        return (
            <div className={clsx(styles.base, className)}>
                {LOADING_BADGE_WIDTHS.map((width, index) => (
                    <Badge
                        key={index}
                        variant="icon"
                        size="md"
                        icon={loadingBadgeIcon}
                        isLoading={true}
                        loadingWidth={width}
                    />
                ))}
            </div>
        )
    } else {
        return <div className={clsx(styles.base, className)}>{children}</div>
    }
}
